module.exports = __webpack_public_path__ + "static/media/error_icon.92820891.svg";